export const formatNumberToDp = (value, precision = 2) => {
    if (!value) {
        return 0;
    }
    return parseFloat(value.toFixed(precision));
};
//# sourceMappingURL=formatNumberToDp.js.map